import imagen from '../../paginas/img/fotoDefault.jpg'
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

const toDataURL = url => fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
    }))

export const imagenDefault = async () => {
    try {
        const dataUrl = await toDataURL(imagen)
        const resp = dataURLtoFile(dataUrl, 'imagendefault.jpeg');
        return resp
    } catch (error) {
        console.log(error)
    }

}